import { ErrorMessage } from "formik";
import { useEffect, useState } from "react";

interface FormikErrorMessageProps {
  name: string;
}

export const FormikErrorMessage: React.FC<FormikErrorMessageProps> = (
  props,
) => {
  return (
    <ErrorMessage name={props.name}>
      {(msg) => <Message msg={msg} />}
    </ErrorMessage>
  );
};

const Message: React.FC<{ msg: string }> = (props) => {
  const [bottom, setBottom] = useState(0);
  const [ref, setRef] = useState<HTMLDivElement>();
  useEffect(() => {
    if (!ref) return;
    setBottom(-ref.clientHeight);
  }, [ref]);

  return (
    <div
      ref={setRef}
      className="absolute text-red-500 left-0"
      style={{ bottom }}
    >
      {props.msg}
    </div>
  );
};
